import { createQueryNumberToggleHook } from "../../../../stores/useQueryState";

export const useWheelPrice = createQueryNumberToggleHook("price", []);
